module.exports = __webpack_public_path__ + "img/1-3.9fde00e3.svg";